/* 🤖 this file was generated by svg-to-ts */
export const DfIconThumbsDown12: {
  name: 'thumbs-down-12';
  data: string;
} = {
  name: 'thumbs-down-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M6.052 1c.125 0 .249.021.367.063l.781.278c.478.17.8.648.8 1.186v4.445c0 .24-.064.474-.185.676l-1.84 3.065a.56.56 0 0 1-.795.196l-.333-.218a.643.643 0 0 1-.268-.656l.385-2.124c.06-.339-.146-.667-.462-.733l-.043-.007-2.593-.325C1.37 6.77 1 6.314 1 5.776v-.739c0-.131.02-.262.057-.387l.847-2.787C2.061 1.348 2.51 1 3.014 1zm4.281 1c.369 0 .667.269.667.6v4.8c0 .331-.298.6-.667.6h-.666C9.298 8 9 7.731 9 7.4V2.6c0-.331.298-.6.667-.6z"/></svg>`
};
